import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf29.png';

const MarketShareStep11 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Awareness Matters"
    paragraph2={(
      <Fragment>
        Customers need to be aware that your product exists in order to have interest
        and make a purchase. It's why companies spend on marketing to create awareness.<br />
        The marketing spend is generally deployed in various marketing channels including
        traditional (e.g. print, billboards and events/conference) and/or digital (e.g.
        content marketing, email marketing, social media, ads).
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep11;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step11.js